module.exports = __webpack_public_path__ + "static/media/location.d02cd554.svg";